<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #fff;
  /* filter: grayscale(1) !important; */
}

html,
body {
  /* -webkit-filter: grayscale(100%) !important;
  filter: grayscale(1) !important; */
}

/* #app .container .header {
  filter: grayscale(1) !important;
}
#app .container .content {
  filter: grayscale(1) !important;
}
#app .container .footer {
  filter: grayscale(1) !important;
}
#app .container .footer {
  filter: grayscale(1) !important;
}
.popover-gob-item {
  filter: grayscale(1) !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue